import React from 'react';

const Sort = () => {
    return (
        <svg width={27.995} height={14} viewBox="0 0 27.995 14">
            <defs>
                <clipPath id="prefix__a">
                    <path fill="none" d="M0 0h27.995v14H0z" />
                </clipPath>
            </defs>
            <g data-name="Group 1576">
                <g data-name="Repeat Grid 1" clipPath="url(#prefix__a)">
                    <g data-name="Group 1575" fill="#8f99dc">
                        <path
                            data-name="Path 2605"
                            d="M18.995 2h-13a1 1 0 010-2h13a1 1 0 010 2z"
                        />
                        <path
                            data-name="Path 2606"
                            d="M15.995 8h-10a1 1 0 010-2h10a1 1 0 010 2z"
                        />
                        <path
                            data-name="Path 2607"
                            d="M13.745 14h-7.75a1 1 0 010-2h7.75a1 1 0 010 2z"
                        />
                        <path
                            data-name="Path 2608"
                            d="M1.005 2a1 1 0 11-.01-2h.01a1 1 0 010 2z"
                        />
                        <path
                            data-name="Path 2609"
                            d="M1.005 8a1 1 0 11-.01-2h.01a1 1 0 010 2z"
                        />
                        <path
                            data-name="Path 2610"
                            d="M1.005 14a1 1 0 11-.01-2h.01a1 1 0 010 2z"
                        />
                        <g>
                            <path
                                data-name="Path 2611"
                                d="M26.995 10a1 1 0 01-.707-.293l-3.293-3.293-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4A1 1 0 0126.995 10z"
                            />
                            <path
                                data-name="Path 2612"
                                d="M22.995 14a1 1 0 01-1-1V5a1 1 0 112 0v8a1 1 0 01-1 1z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Sort;
